import { OARankingDashboard } from './OARankingDashboard'
import { SupplierDashboard } from './SupplierDashboard'
import { getDashboardRole } from '@/stores/permission'
import { useUser } from '@/stores/app'

export function DashboardPage() {
  const { user } = useUser()
  const role = getDashboardRole(user)

  return (
    <div className="space-y-6">
      {role === 'supplier' ? (
        <SupplierDashboard />
      ) : (
        <OARankingDashboard />
      )}
    </div>
  )
}

export { OARankingDashboard } from './OARankingDashboard'
